import { useMemo, useState, useCallback } from 'react';
import { CDN_IMAGE_CONSTANTS } from '../media/constants.js';
import { getImages, getImagesByBreakpoint } from '../media/index.js';

function useFallbackImage(options) {
  const {
    fallbackImageUrl,
    hasWebpSupport,
    imageParams,
    resolutionsByBreakpoint,
    additionalParameters
  } = options;
  const fallbackImageParams = useMemo(() => {
    const fallbackUrl = fallbackImageUrl.includes('http') ? fallbackImageUrl : `${CDN_IMAGE_CONSTANTS.scene7ImageBaseUrl}${fallbackImageUrl}`;
    return { ...imageParams,
      imageUrl: fallbackUrl
    };
  }, [imageParams, fallbackImageUrl]);
  const fallbackImages = useMemo(() => {
    if (!fallbackImageUrl) {
      return;
    }

    if (resolutionsByBreakpoint) {
      return;
    }

    return getImages({
      imageParams: fallbackImageParams,
      additionalParameters,
      hasWebpSupport
    });
  }, [fallbackImageUrl, resolutionsByBreakpoint, fallbackImageParams, additionalParameters, hasWebpSupport]);
  const fallbackImagesByBreakpoint = useMemo(() => {
    if (!fallbackImageUrl) {
      return;
    }

    if (!resolutionsByBreakpoint) {
      return;
    }

    return getImagesByBreakpoint({
      resolutionsByBreakpoint,
      imageParams: fallbackImageParams,
      additionalParameters,
      hasWebpSupport
    });
  }, [fallbackImageUrl, resolutionsByBreakpoint, fallbackImageParams, additionalParameters, hasWebpSupport]);
  const [hasFallbackImage, setHasFallbackImage] = useState(false);
  const onErrorRenderingImage = useCallback(() => {
    setHasFallbackImage(true);
  }, []);
  return {
    fallbackImages,
    fallbackImagesByBreakpoint,
    hasFallbackImage,
    onErrorRenderingImage
  };
}

export { useFallbackImage };
